<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center">
      <h2>{{ $t('route_dashboard' )}}</h2>
      <v-btn
        v-if="userLoaded && user.can('create_route')"
        outlined
        color="primary"
        to="/route/create">
        <v-icon class="mr-1 ml-n2">mdi-plus</v-icon>
        {{ $t('new_route' )}}
      </v-btn>
    </div>
    <v-row>
      <v-col :cols="cols">
        <route-dashboard-card
          type="active"
          icon="mdi-truck-fast"
          :active-refresh="activeRefresh"
          :title="$tc('active_route', 2)"
          :subtitle="$t('route_dashboard_ui.routes_currently_being_run')"
          :info-text="$t('route_dashboard_ui.active_routes_modal')" />
      </v-col>
      <v-col>
        <route-dashboard-card
          type="recent"
          icon="mdi-truck-check"
          :active-refresh="activeRefresh"
          :title="$t('recent_routes')"
          :subtitle="$t('route_dashboard_ui.routes_completed_in_the_last_24_hours')"
          :info-text="$t('route_dashboard_ui.recent_routes_modal')" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RouteDashboardCard from '@/components/route/RouteDashboardCard'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import { get } from 'lodash'

export default {
  name: 'RouteDashboard',
  components: {
    RouteDashboardCard
  },
  mixins: [
    CurrentUserMixin
  ],
  data () {
    return {
      activeRefresh: true
    }
  },
  computed: {
    cols () {
      return this.$vuetify.breakpoint.width > 1500 ? 6 : 12
    }
  },
  /**
   * Indicate that this component is no longer active to prevent background API
   * calls. This hook is provided and executed by vue-router. Read more at
   * https://router.vuejs.org/guide/advanced/navigation-guards.html
   */
  beforeRouteLeave (to, from, next) {
    this.activeRefresh = false
    this.$nextTick(() => next())
  }
}
</script>

<style scoped>

</style>
